// extracted by mini-css-extract-plugin
module.exports = {"icon":"_2LYvN","more":"_10V0P","small":"_2FCqS","actions":"_1ajqi","extended":"_2TczT","actionsTop":"_2EjLh _1ajqi"};